import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'

import { PaginationContainer } from './styled'

const defaultButton = props => <button {...props}>{props.children}</button>

export default class Pagination extends Component {
  constructor(props) {
    super()

    this.changePage = this.changePage.bind(this)

    this.state = {
      visiblePages: this.getVisiblePages(null, props.pages)
    }
  }

  static propTypes = {
    pages: PropTypes.number,
    page: PropTypes.number,
    PageButtonComponent: PropTypes.any,
    onPageChange: PropTypes.func,
    previousText: PropTypes.string,
    nextText: PropTypes.string
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.pages !== nextProps.pages) {
      this.setState({
        visiblePages: this.getVisiblePages(null, nextProps.pages)
      })
    }

    this.changePage(nextProps.page + 1)
  }

  filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter(page => page <= totalPages)
  }

  getVisiblePages = (page, total) => {
    if (total < 7) {
      return this.filterPages([1, 2, 3, 4, 5, 6], total)
    } else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, total]
      } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total]
      } else {
        return [1, 2, 3, 4, 5, total]
      }
    }
  }

  changePage(page) {
    const activePage = this.props.page + 1

    if (page === activePage) {
      return
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages)

    this.setState({ visiblePages: this.filterPages(visiblePages, this.props.pages) })
    this.props.onPageChange(page - 1)
  }

  render() {
    const { PageButtonComponent = defaultButton } = this.props
    const { visiblePages } = this.state
    const activePage = this.props.page + 1

    return (
      <PaginationContainer>
        <div className='prevPageWrapper'>
          <PageButtonComponent
            className='navigateButton'
            onClick={() => (activePage === 1) ? null : this.changePage(activePage - 1)}
            disabled={activePage === 1}
          >
            <Icon icon='chevron-left' style={{ marginRight: '5px' }} />
            {this.props.previousText}
          </PageButtonComponent>
        </div>
        <div className='visiblePagesWrapper'>
          {visiblePages.map((page, index, array) => {
            return (
              <PageButtonComponent
                key={page}
                className={`numberButton${activePage === page ? ' active' : ''}`}
                onClick={this.changePage.bind(null, page)}
              >
                {array[index - 1] + 2 < page ? `...${page}` : page}
              </PageButtonComponent>
            )
          })}
        </div>
        <div className='nextPageWrapper'>
          <PageButtonComponent
            className='navigateButton'
            onClick={() => (activePage === this.props.pages) ? null : this.changePage(activePage + 1)}
            disabled={activePage === this.props.pages}
          >
            {this.props.nextText}
            <Icon icon='chevron-right' style={{ marginLeft: '5px' }}  />
          </PageButtonComponent>
        </div>
      </PaginationContainer>
    )
  }
}
